import {IApplicationService} from "./application.service.interface";
import {ServiceBase} from "../ServiceBase";
import {IServiceFactoryExtended} from "../service-factory-extended.interface";
import {makeObservable, observable, runInAction} from "mobx";

export class ApplicationService extends ServiceBase implements IApplicationService {
    constructor(services: IServiceFactoryExtended) {
        super(services);
        makeObservable(this);

        this.services.sdk.events.onAppPaused(() => {
            runInAction(() => this.isActive = false);
        });
        this.services.sdk.events.onAppResumed(() => {
            runInAction(() => this.isActive = true);
        });
    }

    @observable.ref
    isActive: boolean = true;

    get currentBrowserTabId(): string {
        return this.services.sdk.getCurrentBrowserTabId();
    }
}